import React from "react";
import { Box, Flex, Heading, Text, SimpleGrid, Button } from "@chakra-ui/react";
import { motion } from "framer-motion";
import pmcBg from "../assets/pmcbg.jpg"; // 🔹 Add your PMC hero background image here

export default function ServicesConsultancy() {
  const MotionBox = motion(Box);

  const processSteps = [
    {
      title: "Project Planning & Feasibility Support",
      desc: "Assist in site assessment, techno-commercial feasibility studies, regulatory clearances, and project structuring.",
    },
    {
      title: "Design & Engineering Review",
      desc: "Review of detailed engineering and design documents to ensure technical adequacy, optimization, and compliance with standards.",
    },
    {
      title: "Tendering & Contractor Selection",
      desc: "Support in preparation of RFPs, evaluation of EPC bids, and finalization of contracts aligned with project objectives.",
    },
    {
      title: "Construction Management & Supervision",
      desc: "On-site monitoring to ensure quality workmanship, adherence to safety standards, progress tracking, and issue resolution.",
    },
    {
      title: "Quality Assurance & Technical Audits",
      desc: "Periodic inspections and audits to ensure materials, equipment, and workmanship meet required specifications and industry standards.",
    },
    {
      title: "Stakeholder Coordination & Commissioning Support",
      desc: "Central coordination with developers, EPCs, OEMs, utilities, and oversight during testing, commissioning, and handover documentation.",
    },
  ];

  return (
    <Box>
      <Box bg="#F5FAF6" color="#305D24">
        {/* Hero Section with Background */}
        <Box
          position="relative"
          shadow="xl"
          mb={10}
          textAlign="center"
          overflow="hidden"
           minH={{ base: "300px", md: "350px" }}
        >
          {/* Background Image */}
          <Box
            position="absolute"
            top={0}
            left={0}
            width="100%"
            height="100%"
            bgImage={`url(${pmcBg})`}
            bgSize="cover"
            bgPosition="center"
            filter="brightness(0.6) blur(2px)"
            zIndex={0}
          />

          {/* Content */}
          <Box
            position="relative"
            zIndex={1}
            color="white"
            p={{ base: 10, md: 16 }}
          >
            <Heading
              fontSize={{ base: "3xl", md: "5xl" }}
              mb={4}
              textShadow="2px 2px 4px rgba(0,0,0,0.7)"
            >
              MW-Scale Project Management Consultancy (PMC)
            </Heading>
            <Text
              fontSize={{ base: "md", md: "lg" }}
              mt={4}
              maxW="3xl"
              mx="auto"
              textShadow="1px 1px 3px rgba(0,0,0,0.6)"
              fontWeight="bold"
            >
              Comprehensive PMC services for MW-Scale solar, hybrid, and storage
              projects.
            </Text>
            <Text
              mt={2}
              maxW="3xl"
              mx="auto"
              textShadow="1px 1px 3px rgba(0,0,0,0.6)"
              fontWeight="bold"
            >
              Acting as the client’s extended technical arm, we provide
              independent oversight across planning, design, construction, and
              commissioning—ensuring projects are delivered on time, within
              budget, and to the highest standards.
            </Text>
          </Box>
        </Box>

        {/* Process Steps with Animation */}
        <Box
          bg="#F5FAF6"
          rounded="2xl"
          p={{ base: 6, md: 12 }}
          mb={10}
          mx={{ base: 4, md: 20 }}
          textAlign="center"
        >
          <Heading
            size="xl"
            mb={10}
            color="#305D24"
            fontSize={{ base: "2xl", md: "5xl" }}
          >
            Our Process
          </Heading>
          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={8}>
            {processSteps.map((step, i) => (
              <MotionBox
                key={i}
                p={6}
                bg="white"
                rounded="xl"
                shadow="md"
                whileHover={{ scale: 1.05 }}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1, duration: 0.6 }}
              >
                <Heading size="md" mb={3} color="#519C36">
                  {step.title}
                </Heading>
                <Text fontSize="sm" color="gray.700">
                  {step.desc}
                </Text>
              </MotionBox>
            ))}
          </SimpleGrid>
        </Box>

        {/* Call to Action */}
        <Flex justify="center" py={10}>
          <Button
            bg="#FBBF24"
            color="#065F46"
            size="lg"
            as="a"
            href="/contact"
            _hover={{ bg: "#F59E0B" }}
          >
            Start a Project
          </Button>
        </Flex>
      </Box>
    </Box>
  );
}
